<template>
  <div>
    <v-card>
      <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="9"> </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="data"
        :label="$t('search')"
        :items-per-page="10"
        class="elevation-1 historic-bet"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
        :search="search"
      >
        <template v-slot:item.id="{ item }">
          <v-btn @click="$copy(item.id)" x-small>
            {{ item.id }}
          </v-btn>
        </template>
        <template v-slot:item.name_user="{ item }">
          <div style="font-size: 12px">
            {{ item.name_user }}
            ({{ item.punter }} {{ item.id_user }})
          </div>
        </template>

        <template v-slot:item.events="{ item }">
          <template v-if="!$vuetify.breakpoint.smAndDown">
            <div class="py-2">
              <div
                v-for="(event, index) in item.events"
                :key="index"
                class="caption"
              >
                {{ event.description }} (
                {{ $infoTable.markets(event.id_market).name_market || "" }} -
                {{ $infoTable.outcomes(event.id_outcome).name_outcome || "" }} -
                {{ event.factor_event }}) &nbsp;
                <span
                  class="font-weight-black"
                  v-html="
                    $infoTable.conference(
                      event.result_event,
                      event.status_event
                    )
                  "
                ></span>
                <v-chip
                  class="ml-2 font-weight-black"
                  small
                  color="primary"
                  v-if="event.live_event == '1'"
                >
                  {{ $t("live") }}
                </v-chip>
                <v-chip
                  class="ml-2 font-weight-black"
                  small
                  color="warning"
                  v-if="
                    legendActiveEvent[event.active_event] &&
                      event.status_event == 1
                  "
                >
                  {{ legendActiveEvent[event.active_event] }}
                </v-chip>
              </div>
            </div>
          </template>
          <template v-else>
            {{ item.events.length }}
          </template>
        </template>

        <template v-slot:item.date="{ item }">
          <span class="caption">{{ item.date }}</span>
        </template>

        <template v-slot:item.prize="{ item }">
          <span>{{ item.prize }}</span>
        </template>

        <template v-slot:item.paid="{ item }">
          <v-icon :color="item.paid == 0 ? 'orange' : 'green'">{{
            item.paid | formatPaid
          }}</v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn-toggle dense>
            <v-btn
              small
              title="Vizualizar"
              @click="$bet.showBetDialogOnline(item.id)"
            >
              <v-icon size="24">mdi-magnify-plus-outline</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>

        <template v-slot:item.result_bet="{ item }">
          <div
            class="font-weight-black"
            v-html="$infoTable.conference(item.result_bet, item.status_bet)"
          ></div>
        </template>
      </v-data-table>
    </v-card>
    <!-- Resume Perído -->
    <div class="mt-4" v-if="resume.prizeTotal && resume.amountTotal">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-card class="pa-3">
            <div class="subtitle-1 mb-2">{{ $t("periodSummary") }}</div>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>{{ $t("value") }}</td>
                    <td class="text-right green--text darken-4">
                      {{ resume.amountTotal }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("paidPremiuns") }}</td>
                    <td class="text-right red--text darken-4">
                      {{ resume.prizePaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("passibleAwards") }}</td>
                    <td class="text-right orange--text darken-4">
                      {{ resume.prizeNoPaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("totalPrizes") }}</td>
                    <td class="text-right grey--text darken-4">
                      {{ resume.prizeTotal }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "administrator-bet-list-online",
  props: ["enableTabs"],
  data: () => ({
    data: [],
    search: "",

    resume: {},
    getPlayerBetsTimeoutId: 0,
  }),
  computed: {
    headers() {
      return [
        // Coluna "Oculta" com string com informações
        // para serem encontradas na busca.
        { text: "String p/ Search", value: "infoString", align: " d-none" },
        // Exibidos
        { text: this.$t("code"), value: "id" },
        { text: this.$t("player"), value: "name_user" },
        { text: this.$t("events"), value: "events" },
        { text: this.$t("dateTime"), value: "date" },
        { text: this.$t("value"), value: "amount" },
        { text: this.$t("return"), value: "prize" },
        { text: this.$t("result"), value: "result_bet" },
        { text: this.$t("paid"), value: "paid" },
        { text: this.$t("actions"), value: "action" },
      ];
    },
    legendActiveEvent() {
      return {
        4: this.$t("canceledList"),
        5: this.$t("deferredList"),
        6: this.$t("canceledList"),
        7: this.$t("canceledList"),
      };
    },
    // ====================================================
    // Retrieve Filters:
    id_player() {
      return this.$store.state.filters.autocompletePlayers.id;
    },
    status() {
      return this.$store.state.filters.selectStatusBet.status;
    },
    result() {
      return this.$store.state.filters.selectResultBet.result;
    },
    type() {
      return this.$store.state.filters.selectTypeBet.type;
    },
    sinalOption() {
      return this.$store.state.filters.sinal.option;
    },
    sinalValor() {
      return this.$store.state.filters.sinal.valor;
    },
    sinalAwardOption() {
      return this.$store.state.filters.sinalAward.option;
    },
    sinalAwardValor() {
      return this.$store.state.filters.sinalAward.valor;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    // ====================================================
    // Retrieve Range:
    rangeDate() {
      return this.$store.state.range.date;
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    fetchBetsUserRetail() {
      return this.$store.getters.getFetchBetsUserRetail;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
  },
  watch: {
    // refresh(val) {
    //   val && this.getPlayerBets();
    //   this.$store.commit("setRefresh", false);
    // },
    saveFilters(val) {
      val && this.debounceGetPlayerBets();
    },
    fetchBetsUserRetail(val) {
      if (val) {
        this.debounceGetPlayerBets();
      }
    },
  },
  methods: {
    // Resolve o caso de chamar 2x a função
    debounceGetPlayerBets() {
      clearInterval(this.getPlayerBetsTimeoutId);

      this.getPlayerBetsTimeoutId = setTimeout(() => {
        this.getPlayerBets();
      }, 100);
    },
    async getPlayerBets() {
      if (this.enableTabs != 1) {
        return;
      }

      if (!this.id_player) {
        this.playerIsRequired();
        return;
      }

      const body = {
        ...this.rangeDate,
        status: this.status,
        resultado: this.result,
        sinal_option: this.sinalOption,
        sinal_valor: this.sinalValor,
        id_jogador: this.id_player,
        bets_type: "deposit",
        export: this.exportDoc,
      };
      // Caso o ADM limpe o campo do nome do usuário, bloqueia
      // o search e informa que aqui só trabalhamos com nomes!
      // Sem esse tratamento, o request seria feito e retornaria todas as apostas,
      // o que não tem necessidade nessa view(Este endpoint é compartilhado com a view de Online).
      // if (!this.id_player) {
      // this.playerIsRequired();
      // return;
      // }
      let response;

      if (this.exportDoc) {
        const extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "/administrator/bets/listPlayer",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "/administrator/bets/listPlayer",
          body
        );
        var data = response.length == 0 ? [] : response.dados.apostas;
        // Handle data (important!):
        this.data = await Promise.all(
          this.handleDate(data),
          this.handleInfos(data)
        );
        //Build Resume
        this.resume = this.$resume.resumeBet(this.data);

        this.$store.commit("setFetchBetsUserRetail", false);
      }
    },

    // Handle 'date' (tratamento da data)
    handleDate(data) {
      return data.map(async (item) => {
        item.date = new Date(item.date.replace(" ", "T")).toLocaleString();
        return item;
      });
    },

    // Handle 'string' para alguns dados serem encontrados na busca.
    handleInfos(data) {
      return data.map(async (item) => {
        let infoString = `${item.punter} ${item.name_user} ${item.id_user}`;
        for (const e of item.events) {
          infoString += `${e.description}
          ${this.$infoTable.markets(e.id_market).name_market}
          ${this.$infoTable.outcomes(e.id_outcome).name_outcome}
          ${this.$infoTable.results(item.result_bet)}`;
        }
        Object.assign(item, { infoString });
        return item;
      });
    },
    playerIsRequired() {
      this.$store.commit("setFetchBetsUserRetail", false);
      this.$store.commit("setFeedbackSnack", {
        msg: this.$t("playerNameIsRequired"),
        color: "warning",
      });
      this.$store.commit("setSave", false);
      this.$store.commit("DisabledSave", false);
    },
  },
  filters: {
    formatPaid(val) {
      const format = val == 1 ? "mdi-check" : "mdi-close";
      return format;
    },
  },
};
</script>
<style>
/* Oculta no mobile 'events_edited' e 'Valor_some' */
.historic-bet.v-data-table tbody td:last-child {
  height: 56px !important;
}
.historic-bet td.v-data-table__mobile-row:nth-child(1) {
  display: none;
}
.historic-bet td.v-data-table__mobile-row:nth-child(2) {
  height: 56px !important;
  font-size: 18px;
}
</style>
